<template>
  <div v-if='loading'>
    <oil-cap
        :items='acts'
        :title="'Акт сверки'.toUpperCase()"
        :buttons="[{ route: 'act',  name: 'Добавить акт сверки' }]"
        :search-filter='onSearchValueChange'
        service-name="act"
    />
    <v-divider class='my-2'/>

    <oil-table
        :hide-footer="true"
        :item-counts="acts.length+1"
        :keys="[
                {
                  text:'Покупатель',
                  value:'CompanyName'
                },
                {
                  text:'Договор',
                  value:'ContractNumber'
                },
               {
                  text:'ИНН',
                  value:'TaxNo'

                },
                {
                  text:'Акт сверки',
                  value:'Number'
                },
                // {
                //   text:'Статус',
                //   value:'Status'
                // },
                {
                  text:'',
                  value:'PDFID'
                },
                {
                  text:'',
                  value:'Id'
                },
                {
                  text:'',
                  value:'DeleteId'
                },
             ]"
        :paginate='count'
        @paginateAction='paginate'
        :items='acts'
    >
      <template v-slot:PDFID='{value}'>
        <v-tooltip bottom>
          <template v-slot:activator='{ on, attrs }'>
            <v-btn class='mr-6' type='button' icon
                   @click="showMePdf('act/print',value)"
                   v-bind='attrs'
                   v-on='on'
            >
              <v-icon>
                mdi-pdf-box
              </v-icon>
            </v-btn>
          </template>
          <span>СКАЧАТЬ И ПЕЧАТЬ</span>
        </v-tooltip>
      </template>
      <template v-slot:Id='{value}'>
        <v-tooltip bottom>
          <template v-slot:activator='{ on, attrs }'>
            <v-btn v-bind='attrs'
                   v-on='on' icon
                   @click='handleRowClick(value)'>
              <v-icon color='primary'>
                mdi-pen
              </v-icon>
            </v-btn>
          </template>
          <span>РЕДАКТИ́РОВАТЬ</span>
        </v-tooltip>
      </template>

      <template v-slot:DeleteId='{value}'>
        <v-row>
          <v-col
              md='6'
              offset-md='3'
          >
            <oil-modal
                :value='value'
                tooltipMessage='УДАЛИТЬ'
                mdiIcon='mdi-delete'
                :accept='accept'
            />
          </v-col>
        </v-row>
      </template>
    </oil-table>
  </div>
</template>

<script>
import {actService} from '@/services/actService'
import {coreApi} from '~/services/core'

export default {
  data: () => ({
    acts: [],
    count: {
      count: 0
    },
    statusLocal: {
      active: 'Активный',
      notsigned: 'Неподписанный',
      special: 'Особый',
      inactive: 'Неактивный'
    },
    loading: false
  }),
  components: {
    OilTable: () => import('@/components/helper/oil.table'),
    OilModal: () => import('@/components/helper/form/oil.delete.modal'),
    OilCap: () => import('@/components/helper/oil.cap')
  },
  async created() {
    await this.paginate((this.currentPage - 1) * 10)
    this.loading = true
  },
  methods: {
    openPdf(id, path) {
      window.open(process.env.VUE_APP_BACKEND_API + `/${path}/${id}`)
    },
    close() {
      this.dialog = false
    },
    async accept(id) {
      const isDelete = await actService.delete(id)
      if (isDelete.data) {
        const act = this.acts.find(({Id}) => Id === id)
        const index = this.acts.indexOf(act)
        this.acts.splice(index, 1)
        this.$notify({
          group: 'mgs',
          type: 'success',
          title: `Акт сверки под номером ${act.Number} удачно удален`
        })
      }
    },

    async paginate(page) {
      const acts = await actService.paginate(page)
      console.log(acts.data)
      const {count, dates} = acts.data
      this.count.count = count
      this.acts = dates?.map(act => {
        return {
          Id: act?.Id,
          PDFID: act?.Id,
          DeleteId: act?.Id,
          Number: act?.Number,
          // Status: this.statusLocal[act?.Status],
          CompanyName: act?.Buyer?.CompanyName,
          TaxNo: act.Buyer?.TaxNo,
          ContractNumber: act?.Contract?.Number
        }
      }) || []
    },
    async onSearchValueChange(data) {
      if (!data) {
        await this.paginate((this.currentPage - 1) * 10)
        return
      }
      this.acts =  data?.map(act => {
        return {
          Id: act?.Id,
          PDFID: act?.Id,
          DeleteId: act?.Id,
          Number: act?.Number,
          // Status: this.statusLocal[act?.Status],
          CompanyName: act?.Buyer?.CompanyName,
          TaxNo: act.Buyer?.TaxNo,
          ContractNumber: act?.Contract?.Number
        }
      })
    },
    test(dialog) {
      this.dialog = dialog
    },
    handleRowClick(id) {
      this.$router.push(`act/${id}`)
    }
  }

}
</script>
